export const Mutations = Object.freeze({
	SET_REFERENCE_LIST_TYPES:
		'projectSettings/referenceLists/SET_REFERENCE_LIST_TYPES',
	ADD_REFERENCE_LIST_TYPE:
		'projectSettings/referenceLists/ADD_REFERENCE_LIST_TYPE',
	UPDATE_REFERENCE_LIST_TYPE:
		'projectSettings/referenceLists/UPDATE_REFERENCE_LIST_TYPE',
	DELETE_REFERENCE_LIST_TYPE:
		'projectSettings/referenceLists/DELETE_REFERENCE_LIST_TYPE',
	SET_SELECTED_REFERENCE_LIST_TYPE:
		'projectSettings/referenceLists/SET_SELECTED_REFERENCE_LIST_TYPE',

	SET_REFERENCE_LIST_VALUES:
		'projectSettings/referenceLists/SET_REFERENCE_LIST_VALUES',
	SET_SELECTED_REFERENCE_LIST_VALUE:
		'projectSettings/referenceLists/SET_SELECTED_REFERENCE_LIST_VALUE',
	ADD_REFERENCE_LIST_VALUE:
		'projectSettings/referenceLists/ADD_REFERENCE_LIST_VALUE',
	UPDATE_REFERENCE_LIST_VALUE:
		'projectSettings/referenceLists/UPDATE_REFERENCE_LIST_VALUE',
	DELETE_REFERENCE_LIST_VALUE:
		'projectSettings/referenceLists/DELETE_REFERENCE_LIST_VALUE',

	SET_LOADING: 'projectSettings/dataFields/SET_LOADING',
});

export const Actions = Object.freeze({
	LOAD_REFERENCE_LIST_TYPES:
		'projectSettings/referenceLists/LOAD_REFERENCE_LIST_TYPES',
	LOAD_SELECTED_REFERENCE_LIST_TYPE:
		'projectSettings/referenceLists/LOAD_SELECTED_REFERENCE_LIST_TYPE',

	ADD_REFERENCE_LIST_TYPE:
		'projectSettings/referenceLists/ADD_REFERENCE_LIST_TYPE',
	UPDATE_REFERENCE_LIST_TYPE:
		'projectSettings/referenceLists/UPDATE_REFERENCE_LIST_TYPE',
	DELETE_REFERENCE_LIST_TYPE:
		'projectSettings/referenceLists/DELETE_REFERENCE_LIST_TYPE',

	ADD_REFERENCE_LIST_VALUE:
		'projectSettings/referenceLists/ADD_REFERENCE_LIST_VALUE',
	UPDATE_REFERENCE_LIST_VALUE:
		'projectSettings/referenceLists/UPDATE_REFERENCE_LIST_VALUE',
	DELETE_REFERENCE_LIST_VALUE:
		'projectSettings/referenceLists/DELETE_REFERENCE_LIST_VALUE',
	REORDER_REFERENCE_LIST_VALUES:
		'projectSettings/referenceLists/REORDER_REFERENCE_LIST_VALUES',
	CLEAR_REFERENCE_LIST_VALUES:
		'projectSettings/referenceLists/CLEAR_REFERENCE_LIST_VALUES',

	CLEAR: 'projectSettings/referenceLists/CLEAR',
});

export const Getters = Object.freeze({
	GRID_LOADING: 'projectSettings/referenceLists/GRID_LOADING',
	REFERENCE_LIST_TYPES: 'projectSettings/referenceLists/REFERENCE_LIST_TYPES',
	REFERENEC_LIST_VALUES:
		'projectSettings/referenceLists/REFERENEC_LIST_VALUES',
});

import dataService from '../../../../../services/data/projectSettingsService';
import { GeneralActions, GridsActions } from '../../../../actions';
export default {
	state: {
		referenceListTypes: [],
		selectedReferenceListType: null,
		referenceListValues: [],
		selectedReferenceListValue: null,
		loading: false,
	},
	mutations: {
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_REFERENCE_LIST_TYPES](state, items) {
			state.referenceListTypes = items;
		},
		[Mutations.ADD_REFERENCE_LIST_TYPE](state, item) {
			state.referenceListTypes.push(item);
		},
		[Mutations.UPDATE_REFERENCE_LIST_TYPE](state, item) {
			const index = state.referenceListTypes.findIndex(
				(x) => x.Id == item.Id
			);
			if (index >= 0) {
				state.referenceListTypes.splice(index, 1, item);
			}
		},
		[Mutations.DELETE_REFERENCE_LIST_TYPE](state, item) {
			const index = state.referenceListTypes.findIndex(
				(x) => x.Id == item.Id
			);
			if (index >= 0) {
				state.referenceListTypes.splice(index, 1);
			}
		},
		[Mutations.SET_SELECTED_REFERENCE_LIST_TYPE](state, item) {
			state.selectedReferenceListType = item;
		},

		[Mutations.SET_REFERENCE_LIST_VALUES](state, items) {
			state.referenceListValues = items;
		},
		[Mutations.SET_SELECTED_REFERENCE_LIST_VALUE](state, item) {
			state.selectedReferenceListValue = item;
		},
		[Mutations.ADD_REFERENCE_LIST_VALUE](state, item) {
			state.referenceListValues.push(item);
		},

		[Mutations.UPDATE_REFERENCE_LIST_VALUE](state, item) {
			const index = state.referenceListValues.findIndex(
				(x) => x.Id == item.Id
			);
			if (index >= 0) {
				state.referenceListValues.splice(index, 1, item);
			}
		},
		[Mutations.DELETE_REFERENCE_LIST_VALUE](state, item) {
			const index = state.referenceListValues.findIndex(
				(x) => x.Id == item.Id
			);
			if (index >= 0) {
				state.referenceListValues.splice(index, 1);
			}
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			commit(Mutations.SET_REFERENCE_LIST_VALUES, []);
			commit(Mutations.SET_SELECTED_REFERENCE_LIST_VALUE, null);
			commit(Mutations.SET_SELECTED_REFERENCE_LIST_TYPE, null);
			commit(Mutations.SET_REFERENCE_LIST_TYPES, []);
			commit(Mutations.SET_LOADING, false);
		},
		[Actions.LOAD_REFERENCE_LIST_TYPES]({ commit, dispatch }) {
			dispatch(GeneralActions.LOADING, true);
			return new Promise((resolve) => {
				dataService
					.getReferenceListTypes()
					.then((resp) => {
						commit(Mutations.SET_REFERENCE_LIST_TYPES, resp.data);
						dispatch(GeneralActions.LOADING, true);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, true);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},
		[Actions.LOAD_SELECTED_REFERENCE_LIST_TYPE](
			{ commit, dispatch },
			type
		) {
			commit(Mutations.SET_LOADING, true);
			dispatch(GeneralActions.LOADING, true);
			return new Promise((resolve) => {
				if (type) {
					dataService
						.getReferenceListValuesByTypeId(type.Id)
						.then((resp) => {
							commit(
								Mutations.SET_SELECTED_REFERENCE_LIST_TYPE,
								type
							);
							commit(
								Mutations.SET_REFERENCE_LIST_VALUES,
								resp.data
							);
							commit(Mutations.SET_LOADING, false);
							dispatch(GeneralActions.LOADING, false);
						})
						.catch((error) => {
							commit(Mutations.SET_LOADING, false);
							dispatch(GeneralActions.LOADING, false);

							dispatch(GeneralActions.ERROR, error);
							resolve();
						});
				} else {
					dispatch(GeneralActions.LOADING, false);

					commit(Mutations.SET_REFERENCE_LIST_VALUES, []);
					commit(Mutations.SET_LOADING, false);
					resolve();
				}
			});
		},

		[Actions.ADD_REFERENCE_LIST_TYPE]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.addReferenceListType(item)
					.then((resp) => {
						commit(Mutations.ADD_REFERENCE_LIST_TYPE, resp.data);
						return dispatch(
							GridsActions.RELOAD_REFERENCE_LIST_TYPES
						);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},

		[Actions.UPDATE_REFERENCE_LIST_TYPE]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateReferenceListType(item)
					.then(() => {
						commit(Mutations.UPDATE_REFERENCE_LIST_TYPE, item);
						return dispatch(
							GridsActions.RELOAD_REFERENCE_LIST_TYPES
						);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},

		[Actions.DELETE_REFERENCE_LIST_TYPE]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.removeReferenceListType(item.Id)
					.then(() => {
						commit(Mutations.DELETE_REFERENCE_LIST_TYPE, item);
						return dispatch(
							GridsActions.RELOAD_REFERENCE_LIST_TYPES
						);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},

		[Actions.ADD_REFERENCE_LIST_VALUE]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				item.order = state.referenceListValues.length + 1;
				dataService
					.addReferenceListValue(item)
					.then((resp) => {
						resp.data.TypeName = item.TypeName;
						commit(Mutations.ADD_REFERENCE_LIST_VALUE, resp.data);
						return dispatch(
							GridsActions.RELOAD_REFERENCE_LIST_VALUES
						);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},

		[Actions.UPDATE_REFERENCE_LIST_VALUE]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateReferenceListValue(item)
					.then((resp) => {
						commit(
							Mutations.UPDATE_REFERENCE_LIST_VALUE,
							resp.data
						);
						return dispatch(
							GridsActions.RELOAD_REFERENCE_LIST_VALUES
						);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},

		[Actions.DELETE_REFERENCE_LIST_VALUE]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.removeReferenceListValue(item.Id)
					.then(() => {
						commit(Mutations.DELETE_REFERENCE_LIST_VALUE, item);
						return dispatch(
							GridsActions.RELOAD_REFERENCE_LIST_VALUES
						);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},
		[Actions.REORDER_REFERENCE_LIST_VALUES]({ dispatch }, items) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let payload = {
					ReferenceListValue: items.map((x) => ({
						Id: x.Id,
						Order: x.Order,
					})),
				};
				dataService
					.reorderReferenceListValues(payload)
					.then(() => {})
					.then(() => {
						dispatch(GridsActions.RELOAD_REFERENCE_LIST_VALUES);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},
		[Actions.CLEAR_REFERENCE_LIST_VALUES]({ commit }) {
			commit(Mutations.SET_REFERENCE_LIST_VALUES, []);
		},
	},
	getters: {
		[Getters.GRID_LOADING]: (state) => {
			return state.loading;
		},
		[Getters.REFERENCE_LIST_TYPES]: (state) => {
			if (
				state.referenceListTypes &&
				state.referenceListTypes.length > 0
			) {
				return JSON.parse(
					JSON.stringify(
						state.referenceListTypes.sort((a, b) =>
							a.Name > b.Name ? 1 : -1
						)
					)
				);
			}
			return [];
		},
		[Getters.REFERENEC_LIST_VALUES]: (state) => {
			if (
				state.referenceListValues &&
				state.referenceListValues.length > 0
			) {
				return JSON.parse(
					JSON.stringify(
						state.referenceListValues.sort(
							(a, b) => a.Order - b.Order
						)
					)
				);
			}
			return [];
		},
	},
};
